import { render, staticRenderFns } from "./BestellingendagTable.vue?vue&type=template&id=c5861246&scoped=true&"
import script from "./BestellingendagTable.vue?vue&type=script&lang=js&"
export * from "./BestellingendagTable.vue?vue&type=script&lang=js&"
import style0 from "./BestellingendagTable.vue?vue&type=style&index=0&id=c5861246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5861246",
  null
  
)

export default component.exports